import type { Root } from "./prototypeTypes";
import type { MediaKind } from "./mediaPlayerTypes";
import { activateMediaSessionPlayer, mountedFor } from "./mediaPlayerCore";
import { toggleVideoPictureInPicturePresentation } from './videoPictureInPicture';

export function cycleMediaPlaybackRate(root: Root, kind: MediaKind, rates = [1, 1.25, 1.5, 1.75, 2]): number {
  const media = mountedFor(root, kind);
  if (!media) return 1;
  const current = media.element.playbackRate || 1;
  const currentIndex = rates.findIndex((rate) => Math.abs(rate - current) < 0.01);
  const next = rates[(currentIndex + 1) % rates.length] ?? 1;
  media.element.playbackRate = next;
  return next;
}

export async function toggleVideoPictureInPicture(root: Root): Promise<boolean> {
  const media = mountedFor(root, "video");
  const video = media?.element instanceof HTMLVideoElement ? media.element : null;
  if (!video) return false;
	activateMediaSessionPlayer(root, 'video');
	return toggleVideoPictureInPicturePresentation(video);
}
